import { Box, Button } from "@mui/material";
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import RestoreIcon from '@mui/icons-material/Restore';
import { Snapshot } from "@shared/domain/snapshot/snapshot.aggregate";
import { snapshotRepository } from "@shared/domain/snapshot/snapshot.repository";
import { countryCodeSelector } from "@shared/infrastructure/state/global.slice";
import { useAppSelector } from "@shared/infrastructure/state/store";
import { DashboardLayout } from "@shared/infrastructure/ui/layout/dashboardLayout"
import { useEffect, useState } from "react";
import { Toast } from "@shared/infrastructure/ui/components/toast/toast";
import { SnapshotCreate, SnapshotCreateProps } from "./snapshotCreate";
import { SnapshotRestore, SnapshotRestoreProps } from "./snapshotRestore";

export const SnapshotView = () => {
    const countryCode = useAppSelector(countryCodeSelector);

    const [snapshots, setSnapshots] = useState<Snapshot[]>([]);
    const [isBusy, setIsBusy] = useState(false);
    const [toast, setToast] = useState<{
        message: string;
        isError: boolean;
    }>();
    const [createDialogProps, setCreateDialogProps] = useState<SnapshotCreateProps>();
    const [restoreDialogProps, setRestoreDialogProps] = useState<SnapshotRestoreProps>();

    useEffect(() => {
        setIsBusy(true);
        snapshotRepository
            .getSnapshots(countryCode)
            .then((snapshots) => {
                setSnapshots(snapshots);
            })
            .finally(() => {
                setIsBusy(false);
            });
    }, [countryCode]);

    const DisplaySuccessMessage = (message: string) =>
        setToast({ message, isError: false });

    const OnCreateSnapshot = () => setCreateDialogProps({
        countryCode: countryCode,
        onCancel: () => setCreateDialogProps(undefined),
        onSubmit: (snapshot: Snapshot) => {
            setSnapshots([snapshot, ...snapshots]);
            DisplaySuccessMessage("Snapshot created.");
            setCreateDialogProps(undefined);
        }
    });

    const OnRestoreSnapshot = () => setRestoreDialogProps({
        countryCode: countryCode,
        snapshots: snapshots,
        onCancel: () => setRestoreDialogProps(undefined),
        onSubmit: () => {
            DisplaySuccessMessage("Snapshot restored.");
            setRestoreDialogProps(undefined);
        }
    });

    return (
        <>
            <DashboardLayout>
                <Box
                    sx={{
                        marginTop: '2rem',
                    }}
                >
                    <Button
                        variant='contained'
                        onClick={OnCreateSnapshot}
                        disabled={isBusy}
                        sx={{
                            marginRight: '2rem',
                        }}
                        startIcon={<BookmarkAddIcon />}
                    >
                        Create
                    </Button>
                    <Button
                        variant='contained'
                        onClick={OnRestoreSnapshot}
                        disabled={!snapshots.length || isBusy}
                        startIcon={<RestoreIcon />}
                    >
                        Restore
                    </Button>
                </Box>
            </DashboardLayout>

            {toast && (
                <Toast
                    isError={toast.isError}
                    message={toast.message}
                    onClose={() => setToast(undefined)}
                ></Toast>
            )}

            {createDialogProps && (
                <SnapshotCreate {...createDialogProps}
                ></SnapshotCreate>
            )}

            {restoreDialogProps && (
                <SnapshotRestore {...restoreDialogProps}
                ></SnapshotRestore>
            )}
        </>
    )
}